import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainPageModule)
  },
  {
    path: 'cursos',
    loadChildren: () => import('./pages/cursos/cursos.module').then( m => m.CursosPageModule)
  },
  {
    path: 'documentos',
    loadChildren: () => import('./pages/documentos/documentos.module').then( m => m.DocumentosPageModule)
  },
  {
    path: 'ayuda',
    loadChildren: () => import('./pages/ayuda/ayuda.module').then( m => m.AyudaPageModule)
  },
  {
    path: 'administrador',
    loadChildren: () => import('./pages/administrador/administrador.module').then( m => m.AdministradorPageModule)
  },
  {
    path: 'crear-editar-documento',
    loadChildren: () => import('./pages/documentos/crear-editar-documento/crear-editar-documento.module').then( m => m.CrearEditarDocumentoPageModule)
  },
  {
    path: 'crear-editar-documento-categoria',
    loadChildren: () => import('./pages/documentos/crear-editar-documento-categoria/crear-editar-documento-categoria.module').then( m => m.CrearEditarDocumentoCategoriaPageModule)
  },
  {
    path: 'crear-editar-libro-categoria',
    loadChildren: () => import('./pages/libros/crear-editar-libro-categoria/crear-editar-libro-categoria.module').then( m => m.CrearEditarLibroCategoriaPageModule)
  },
  {
    path: 'crear-editar-libro',
    loadChildren: () => import('./pages/libros/crear-editar-libro/crear-editar-libro.module').then( m => m.CrearEditarLibroPageModule)
  },
  {
    path: 'crear-editar-curso',
    loadChildren: () => import('./pages/cursos/crear-editar-curso/crear-editar-curso.module').then( m => m.CrearEditarCursoPageModule)
  },
  {
    path: 'crear-editar-curso-categoria',
    loadChildren: () => import('./pages/cursos/crear-editar-curso-categoria/crear-editar-curso-categoria.module').then( m => m.CrearEditarCursoCategoriaPageModule)
  }
  ,
  {
    path: 'registrarse',
    loadChildren: () => import('./pages/usuarios/crear-editar-usuario/crear-editar-usuario.module').then( m => m.CrearEditarUsuarioPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
